import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useState } from "react";

const { Search } = Input;

const SearchBar = ({
  onSearch,
  defaultValue = null,
  loading = false,
  required = false,
  enableOnChange = false,
  placeholder = "Search Ref No",
}) => {
  const [localValue, setLocalValue] = useState(defaultValue);
  const [localValueChanged, setLocalValueChanged] = useState(false);

  const handleValueChange = (e) => {
    setLocalValue(e.target.value);
    setLocalValueChanged(true);
  };

  return (
    <>
      <Search
        value={localValue}
        onChange={handleValueChange}
        onSearch={(val, _, info) => {
          info.source === "input" && onSearch(val);
        }}
        disabled={loading}
        loading={loading}
        enterButton={
          <Button
            loading={loading}
            disabled={
              (enableOnChange && !localValueChanged) ||
              (required && !localValue)
            }
            type="primary"
            icon={<SearchOutlined />}
          />
        }
        placeholder={placeholder}
        allowClear={true}
        style={{
          width: "20rem",
        }}
      />
    </>
  );
};

export default SearchBar;
